<template>
  <div>
    <el-drawer title="查看明细" :visible.sync="drawer" direction="rtl" size="88%">
      <StatisticalCard :list="getCardList" @check-detail="checkAdjustDetail" class="mb-6" />
      <div class="content flex">
        <article class="h-full" style="width: calc(100% - 234px)">
          <div class="flex items-center">
            <el-tag :type="projectInfo.projectCategory.type" size="mini" style="font-size: 12px; border-width: 0">{{
              projectInfo.projectCategory.text
            }}</el-tag>
            <div class="inline-block font-semibold text-medium-x text-theme-black-850 max-w-lg ml-1">
              <div v-truncate="projectInfo.projectName" class="truncate"></div>
            </div>

            <span class="bg-e8 text-opacity-85 inline-block text-medium rounded-small p-0.5 ml-1">
              <span v-if="isInvestigator">
                到手金额 <b class="num-style">{{ projectInfo.expectedYuanAmount }}</b> 元， 服务费
                <b class="num-style">{{ projectInfo.serviceYuanAmount }}</b> 元，
              </span>
              结算总费用
              <b class="num-style">{{ projectInfo.operationalYuanAmount }}</b> 元
            </span>
          </div>
          <!-- <el-scrollbar class="w-full mt-4" style="height: calc(100% - 36px)" wrap-class="overflow-x-hidden"> -->
          <div class="main bg-white rounded-medium p-4 mt-4 box-border">
            <ul class="flex flex-wrap mb-4">
              <li class="w-1/2 mb-2" v-for="(item, index) in taskInfo" :key="index">
                <label class="opacity-45 text-medium">{{ item.label }}</label>
                <span class="opacity-85 text-medium">{{ item.value }}</span>
              </li>
            </ul>
            <h4 class="opacity-85 text-medium-x mb-4">费用明细</h4>
            <SearchCard ref="searchCard" :searchConfig="searchConfig" @to-search="toSearch" @on-reset="onReset">
              <p class="text-medium flex-1 text-right opacity-85 min-h-8 leading-normal">
                <span
                  class="header-text-style"
                  v-html="getUnitQuantityText(tableHeaderInfo.maxUnitPriceYuan, tableHeaderInfo.unitQuantity)"
                ></span>
                <span v-if="isInvestigator">
                  到手金额 <b class="num-style">{{ tableHeaderInfo.expectedYuanAmount }}</b> 元
                  <!-- ， 服务费
                  <b class="num-style">{{ tableHeaderInfo.serviceYuanAmount }}</b> 元， -->
                </span>
                <!-- 结算总费用
                <b class="num-style">{{ tableHeaderInfo.operationalYuanAmount }}</b> 元 -->
              </p>
            </SearchCard>
            <data-table
              ref="crud"
              align="left"
              :height="'calc(100vh - 477px)'"
              :columns="option.column"
              :isShowCheckAll="option.isShowCheckAll"
              :isShowCheckCount="option.isShowCheckCount"
              :checkAll.sync="checkAll"
              :data="tableData"
              :selection="isSelection"
              :showPage="true"
              :page="pagination"
              :loading="tableLoading"
              @size-change="sizeChange"
              @pagination-current-change="currentChange"
              @selection-change="selectionChange"
            >
              <!-- 审核员 列 -->
              <template #assessorName="{ row }">
                <span>{{ row.assessorName + '-' + row.assessorPhone }}</span>
              </template>
              <!-- 单价 列 -->
              <template #maxUnitPriceYuan="{ row }">
                <span v-if="row.minUnitPriceYuan && row.maxUnitPriceYuan">
                  <span>{{ row.minUnitPriceYuan | getUnitPriceYuanText(row.maxUnitPriceYuan) }}</span>
                </span>
              </template>
              <!-- 到手金额 列 -->
              <template #expectedYuanAmount="{ row }">
                <span>{{ (row.expectedYuanAmount || row.expectedYuanAmount === 0) && row.expectedYuanAmount.toFixed(2) }}</span>
              </template>
              <!-- 结算方式 列 -->
              <template #settleMode="{ row }">
                <span>{{ row.settleMode | getSettleModeT }}</span>
              </template>
              <!-- 数量 列 -->
              <template #unitQuantity="{ row }">
                <span v-if="row.unitQuantity">{{ row.unitQuantity }} {{ row.settleMode | getUnit(row.projectCategory) }}</span>
              </template>
              <!-- 调查时间 列 -->
              <template #investigateStartTime="{ row }">
                <span>{{ handleTime(row.investigateStartTime, row.investigateEndTime) }}</span>
              </template>
              <!-- 执行时间 列 -->
              <template #time="{ row }">
                <span>{{ handleTime(row.investigateStartTime, row.investigateEndTime, 'HH:mm') }}</span>
              </template>
              <template #opt="{ row }">
                <el-button
                  v-if="
                    projectInfo.projectCategory.code === PROJECT_CATEGORY.QUESTIONNAIRE_SURVEY &&
                    settleMode === SETTLE_MODE.ANSWER_NUMBER
                  "
                  @click="toAnswerDetail(row)"
                  type="text"
                  class="mr-3"
                >
                  查看明细
                </el-button>
                <span v-else-if="projectInfo.projectCategory.code === PROJECT_CATEGORY.MANUAL_IMPORT">{{ '' }}</span>
                <el-button v-else type="text" class="mr-3" @click="toDetail(row)"> 查看明细 </el-button>
                <el-popconfirm
                  title="确定移除？移除后无法撤消"
                  @confirm="remove([row.id])"
                  v-if="
                    rows.status == TASK_STATUS.NOT_SUBMITTED ||
                    rows.status == TASK_STATUS.REFUSED ||
                    rows.status == TASK_STATUS.REVOCATION
                  "
                >
                  <el-button type="text" slot="reference"> 移除 </el-button>
                </el-popconfirm>
              </template>
              <template slot="page-left" v-if="removeShow">
                <el-popconfirm title="确定移除？移除后无法撤消" :disabled="removeDisabled" @confirm="mtlRemove()">
                  <el-button
                    type="primary"
                    :disabled="!selectionList.length"
                    @click="!selectionList.length ? mtlRemove() : ''"
                    slot="reference"
                    >移除</el-button
                  >
                </el-popconfirm>
              </template>
            </data-table>
          </div>
          <!-- </el-scrollbar> -->
        </article>
        <aside style="width: 234px" class="tree overflow-hidden">
          <el-tree
            v-if="treeData.length"
            :data="treeData"
            class="bg-transparent"
            :props="defaultProps"
            node-key="id"
            :expand-on-click-node="false"
            :default-expanded-keys="defaultExpandedKeys"
            @node-click="handleNodeClick"
          >
            <span class="custom-tree-node mb-2" slot-scope="{ node, data }">
              <el-tag
                v-if="typeof data.projectCategory === 'number'"
                :type="handleProjectCategory(data.projectCategory).type"
                size="mini"
                style="font-size: 12px; border-width: 0"
                >{{ handleProjectCategory(data.projectCategory).text }}</el-tag
              >
              <span
                :class="['text-medium', 'font-medium', 'opacity-85', 'ml-1', data.checked ? 'active-class' : 'no-active-class']"
                >{{ node.label }}</span
              >
            </span>
          </el-tree>
        </aside>
      </div>
    </el-drawer>
    <DetailViewSub :visible.sync="subVisible" :rows="curRow" :preRows="rows" :pageType="pageType"> </DetailViewSub>
  </div>
</template>

<script>
import DetailViewSub from '@/views/home/cost-settlement/settlement-initiate/relate-project/DetailViewSub'
import StatisticalCard from './StatisticalCard'
import SearchCard from './SearchCard'
import DataTable from '@/components/base/DataTable'
import {
  getInvestigatorDetail,
  getInvestigatorDetailTableInfo,
  getInvestigatorDetailList,
  removeInvestigatorDetail,
  getInvestigatorDetailCardTab,
  getCaseList,
  getCountList,
  importProjectDetail
} from '@/api/cost-settlement/settlement-initiate/submitStatement'
import { itemGroupRemove, itemRemove } from '@/api/cost-settlement/settlement-initiate/relateProject'
import { PROJECT_CATEGORY, SETTLE_MODE, TASK_STATUS, AUDIT_STATUS, PAY_STATUS } from '../settleConst'

import * as column from './CheckDetailDrawerOption'
import mixin from '../mixin'
import store from '@/store'
export default {
  components: { StatisticalCard, SearchCard, DataTable, DetailViewSub },
  mixins: [mixin],
  props: {
    rows: {
      type: Object,
      default: () => ({})
    }
  },
  filters: {
    // ‘单价’列的价格显示
    getUnitPriceYuanText(min, max) {
      if (min && max) {
        if (min === max) {
          return max.toFixed(2)
        } else {
          return min.toFixed(2) + '~' + max.toFixed(2)
        }
      } else {
        return ''
      }
    },
    //‘结算方式’ 列
    getSettleModeT(v) {
      switch (v) {
        case SETTLE_MODE.ANSWER_NUMBER:
          return '按答卷数量'
        case SETTLE_MODE.DAY:
          return '按天'
        case SETTLE_MODE.LADDER_PRICING:
          return '按阶梯计价'
        case SETTLE_MODE.POINT_POSITION:
          return '按点位'
        default:
          return ''
      }
    }
  },
  data() {
    return {
      PROJECT_CATEGORY,
      SETTLE_MODE,
      TASK_STATUS,
      pageType: 1,
      curRow: {},
      subVisible: false,
      drawer: false,
      cardList: [
        {
          label: '调查员',
          value: '',
          code: 'investigatorName',
          valueNote: '',
          valueFontSize: '18',
          valueNoteColor: 'black'
        },
        {
          label: '到手金额(元)',
          value: '',
          valueFixed: 2,
          code: 'expectedYuanAmount',
          labelTip: '调查员实际到手金额（扣除服务费税后）',
          valueNote: '',
          valueTip: '根据调查实际情况，给调查员补扣相应款项，补扣款将计入调查员到手金额',
          clickabel: true
        },
        {
          label: '服务费(元)',
          value: '',
          valueFixed: 2,
          code: 'serviceYuanAmount',
          labelTip: (content) => `服务费 = 调查员到手金额 * ${content}%，服务费用于调查员代缴税及平台技术服务费`
        },
        {
          label: '结算总费用(元)',
          value: '',
          valueFixed: 2,
          code: 'operationalYuanAmount',
          labelTip: '结算总费用 = 调查员到手金额 + 服务费，即实际执行成本'
        }
      ],
      cardListProxy: [
        {
          label: '代理',
          value: '',
          code: 'investigatorName',
          valueFontSize: '18'
        },
        {
          label: '结算总费用(元)',
          value: '',
          valueFixed: 2,
          code: 'operationalYuanAmount',
          valueNote: '',
          clickabel: true,
          labelTip: '代理的结算总费用'
        }
      ],
      tableData: [],
      option: {
        isShowCheckAll: true,
        isShowCheckCount: true,
        column: column.column1
      },
      searchConfig: [],
      pagination: {
        pageSize: 20,
        currentPage: 1,
        total: 0
      },
      treeData: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      projectInfo: {
        projectCategory: {
          //项目类型
          type: '',
          text: ''
        },
        projectName: ''
      },
      taskInfo: [{ label: '任务名称：' }, { label: '结算方式：' }, { label: '调查时间：' }],
      searchData: {},
      id: '',
      cId: '',
      tableHeaderInfo: {}, //表格头部数据
      selectionList: [],
      defaultExpandedKeys: [], //右侧导航默认展开节点
      maxUnitPriceYuan: null,
      checkAll: false,
      tableLoading: false,
      projectId: '',
      investigatorPhone: '',
      taskNums: { num: 0 },
      isSelection: true,
      payStatus: undefined
    }
  },
  computed: {
    getParams() {
      const { time, area } = this.searchData
      const timeValue = {
        investigateTimeStart: time ? time[0] : '',
        investigateTimeEnd: time ? time[1] : ''
      }
      const page = {
        current: this.pagination.currentPage,
        size: this.pagination.pageSize
      }
      const query = { ...timeValue, area: area ?? '', forLink: false }
      return { query, page, data: { ...query, ...page } }
    },

    removeDisabled() {
      return !this.selectionList.length
    },
    removeShow() {
      const res =
        this.rows.status == TASK_STATUS.NOT_SUBMITTED ||
        this.rows.status == TASK_STATUS.REFUSED ||
        this.rows.status == TASK_STATUS.REVOCATION
      this.option.isShowCheckAll = res
      this.option.isShowCheckCount = res
      this.isSelection = res
      return res
    },
    isShowOpt() {
      const { status } = this.rows
      return (
        this.projectInfo.projectCategory.code !== PROJECT_CATEGORY.MANUAL_IMPORT ||
        status == TASK_STATUS.NOT_SUBMITTED ||
        status == TASK_STATUS.REFUSED ||
        status == TASK_STATUS.REVOCATION
      )
    },
    getCardList: {
      set() {},
      get() {
        if (this.isInvestigator) {
          return this.cardList
        } else {
          return this.cardListProxy
        }
      }
    }
  },
  mounted() {},
  methods: {
    toDetail(row) {
      if (
        this.rows.status == TASK_STATUS.NOT_SUBMITTED ||
        this.rows.status == TASK_STATUS.REFUSED ||
        this.rows.status == TASK_STATUS.REVOCATION
      ) {
        this.pageType = 1
      } else {
        this.pageType = 2
      }
      this.rows.projectCategory = this.projectInfo.projectCategory.code
      this.rows.settleMode = this.settleMode
      this.curRow = row
      this.subVisible = true
    },
    toAnswerDetail(row) {
      window.open(
        `${window.location.origin + process.env.VUE_APP_PRE_URL}/#/item-detail/survey?` +
          `answerId=${row.originId}&investigatorName=${row.investigatorName}&investigatorPhone=${row.investigatorPhone}`
      )
    },
    //项目、任务信息 （除导入外）
    getInvestigatorDetail() {
      getInvestigatorDetail(this.cId, { forLink: false })
        .then(result => {
          this.handleProjectInfo(result)
        })
        .catch(err => {})
    },
    //项目、任务信息 （导入的）
    importProjectDetail() {
      importProjectDetail({ projectId: this.cId, investigatorStatementId: this.id }).then(result => {
        this.handleProjectInfo(result)
      })
    },
    handleProjectInfo(result) {
      if (result.data.code !== 0) return
      const { data } = result.data
      //处理 项目信息
      const { serviceYuanAmount, operationalYuanAmount, expectedYuanAmount, projectName, projectCategory } = data
      this.projectInfo = {
        serviceYuanAmount: serviceYuanAmount?.toFixed(2),
        operationalYuanAmount: operationalYuanAmount?.toFixed(2),
        expectedYuanAmount: expectedYuanAmount?.toFixed(2),
        projectName,
        projectCategory: this.handleProjectCategory(projectCategory)
      }
      // 任务信息
      const { taskName, settleMode, investigateStartTime, investigateEndTime, maxUnitPriceYuan, settleRule } = data
      this.maxUnitPriceYuan = maxUnitPriceYuan
      this.taskInfo = [
        { label: '任务名称：', value: taskName ?? '其他任务' },
        { label: '结算方式：', value: this.getSettleModeText(settleMode, maxUnitPriceYuan, settleRule?.tiers) },
        {
          label: '调查时间：',
          value: this.handleTime(investigateStartTime, investigateEndTime)
        }
      ]
      // -- 如果是人工导入 只显示调查时间
      if (this.projectInfo.projectCategory.code === PROJECT_CATEGORY.MANUAL_IMPORT) {
        this.taskInfo = this.taskInfo.slice(2, 3)
      }
      //存 settleMode
      this.settleMode = settleMode
      //设置搜索项
      this.setSearchConfig(projectCategory, settleMode)
      //获取表格数据
      this.getList()
    },
    //表格数据
    getList() {
      this.checkAll = false
      this.$refs.crud?.clearSelection()

      this.tableLoading = true
      const projectCategory = this.projectInfo.projectCategory.code
      const settleMode = this.settleMode
      /*
        人工导入（projectCategory 区分）：查调查员任务明细（investigatorDetail ）07
        问卷-按答卷数量（settleMode 区分）：查答卷案件（item）01
        其余：查计数明细（itemGroup）
      */
      if (projectCategory === PROJECT_CATEGORY.MANUAL_IMPORT) {
        this.getInvestigatorDetailList(projectCategory, settleMode)
      } else if (projectCategory === PROJECT_CATEGORY.QUESTIONNAIRE_SURVEY && settleMode === SETTLE_MODE.ANSWER_NUMBER) {
        this.getCaseList(projectCategory, settleMode)
      } else {
        this.getCountList(projectCategory, settleMode)
      }
    },
    //人工导入列表
    getInvestigatorDetailList(projectCategory, settleMode) {
      getInvestigatorDetailList(this.getParams.page, {
        ...this.getParams.query,
        investigatorStatementId: this.id,
        projectId: this.cId
      })
        .then(res => {
          if (res.data.code !== 0) {
            return
          }
          this.tableData = res.data.data.records
          this.pagination.total = res.data.data.total
          const { expectedYuanAmount, serviceYuanAmount, operationalYuanAmount } = res.data.data
          this.tableHeaderInfo = {
            expectedYuanAmount: expectedYuanAmount?.toFixed(2),
            serviceYuanAmount: serviceYuanAmount?.toFixed(2),
            operationalYuanAmount: operationalYuanAmount?.toFixed(2),
            unitQuantity: res.data.data.total,
            maxUnitPriceYuan: this.maxUnitPriceYuan
          }
          //设置表格列配置
          this.setColumn(projectCategory, settleMode)
          this.$nextTick(() => {
            this.$refs.crud.doLayout()
          })
        })
        .catch(err => {})
        .finally(() => {
          this.tableLoading = false
        })
    },
    //问卷-按答卷数量
    getCaseList(projectCategory, settleMode) {
      getCaseList({ ...this.getParams.data, investigatorDetailId: this.cId })
        .then(res => {
          if (res.data.code !== 0) {
            return
          }
          this.tableData = res.data.data.records
          this.pagination.total = res.data.data.total
          const { expectedYuanAmount, serviceYuanAmount, operationalYuanAmount } = res.data.data
          this.tableHeaderInfo = {
            expectedYuanAmount: expectedYuanAmount?.toFixed(2),
            serviceYuanAmount: serviceYuanAmount?.toFixed(2),
            operationalYuanAmount: operationalYuanAmount?.toFixed(2),
            unitQuantity: res.data.data.total,
            maxUnitPriceYuan: this.maxUnitPriceYuan
          }
          //设置表格列配置
          this.setColumn(projectCategory, settleMode)
          this.$nextTick(() => {
            this.$refs.crud.doLayout()
          })
        })
        .catch(err => {})
        .finally(() => {
          this.tableLoading = false
        })
    },
    //其他情况列表接口
    getCountList(projectCategory, settleMode) {
      getCountList({ investigatorDetailId: this.cId, ...this.getParams.data })
        .then(res => {
          if (res.data.code !== 0) {
            return
          }
          this.tableData = res.data.data.records
          this.pagination.total = res.data.data.total
          const { expectedYuanAmount, serviceYuanAmount, operationalYuanAmount } = res.data.data
          this.tableHeaderInfo = {
            expectedYuanAmount: expectedYuanAmount?.toFixed(2),
            serviceYuanAmount: serviceYuanAmount?.toFixed(2),
            operationalYuanAmount: operationalYuanAmount?.toFixed(2),
            unitQuantity: res.data.data.total,
            maxUnitPriceYuan: this.maxUnitPriceYuan
          }
          //设置表格列配置
          this.setColumn(projectCategory, settleMode)
          this.$nextTick(() => {
            this.$refs.crud.doLayout()
          })
        })
        .catch(err => {})
        .finally(() => {
          this.tableLoading = false
        })
    },
    //统计卡片信息
    getInvestigatorDetailCardTab() {
      getInvestigatorDetailCardTab(this.id).then(res => {
        const { data } = res.data
        //处理统计卡片数据
        this.getCardList.forEach(item => {
          if (item.code !== 'investigatorName') {
            data[item.code] ??= 0
            item.value = data[item.code].toFixed(item.valueFixed ?? 0)
          } else {
            item.value = data[item.code]
          }
          if (item.code === 'investigatorName' && data.investigatorPhone && this.isInvestigator) {
            item.valueNote = data?.investigatorPhone?.replace(this.mobileReg, ' ')
          } else if (item.code === (this.isInvestigator ? 'expectedYuanAmount' : 'operationalYuanAmount')) {
            item.valueNote = data.adjustYuanAmount
              ? `含补扣款${data.adjustYuanAmount > 0 ? '+' + data.adjustYuanAmount.toFixed(2) : data.adjustYuanAmount.toFixed(2)}`
              : ''
          }
        })
      })
    },
    //右侧导航信息
    getInvestigatorDetailTableInfo() {
      const { investigatorPhone, statementId, settleObjType } = this
      getInvestigatorDetailTableInfo({ investigatorPhone, statementId, settleObjType }).then(res => {
        if (res.data.code !== 0) {
          return
        }
        //整理右侧导航数据
        this.treeData = res.data.data
          .map(item => {
            if (JSON.stringify(item) !== '{}') {
              return {
                projectCategory: item.projectCategory,
                label: item.projectName,
                id: item.projectId,
                checked: item.projectCategory === PROJECT_CATEGORY.MANUAL_IMPORT && item.projectId === this.projectId,
                investigatorStatementId: item.detailList[0].investigatorStatementId,
                children:
                  item.projectCategory !== PROJECT_CATEGORY.MANUAL_IMPORT &&
                  item.detailList &&
                  item.detailList.map(task => {
                    return {
                      label: task.taskName ?? '未命名任务' + this.getTaskNums(item),
                      id: task.detailId,
                      checked: task.detailId === this.cId, //默认选中的节点
                      investigatorStatementId: task.investigatorStatementId
                    }
                  })
              }
            }
          })
          .filter(data => data)
        //查找全展开
        this.defaultExpandedKeys = this.treeData.map(item => item.id)
      })
    },
    //单个移除/移除接口
    remove(selectedIds) {
      let query = JSON.parse(JSON.stringify(this.getParams.query))
      // if (selectedIds.length === this.tableData.length) {
      //   query = JSON.parse(JSON.stringify(this.getParams.query))
      // }
      const projectCategory = this.projectInfo.projectCategory.code
      const settleMode = this.settleMode
      if (projectCategory === PROJECT_CATEGORY.MANUAL_IMPORT) {
        this.removeInvestigatorDetail(selectedIds, query)
      } else if (projectCategory === PROJECT_CATEGORY.QUESTIONNAIRE_SURVEY && settleMode === SETTLE_MODE.ANSWER_NUMBER) {
        this.itemRemove(selectedIds, query)
      } else {
        this.itemGroupRemove(selectedIds, query)
      }
    },
    itemRemove(selectedIds, query) {
      itemRemove({ selectedIds, query: { ...query, investigatorDetailId: this.cId } })
        .then(res => {
          if (res.data.code !== 0) {
            this.$message.warning(res.data.msg || '移除失败')
            return
          }
          this.$message.success('移除成功')
          this.getList()
        })
        .finally(() => {
          this.selectionList = []
          this.$refs.crud.clearSelection()
          this.$emit('finished-remove')
        })
    },
    itemGroupRemove(selectedIds, query) {
      itemGroupRemove({ selectedIds, query: { ...query, investigatorDetailId: this.cId } })
        .then(res => {
          if (res.data.code !== 0) {
            this.$message.warning(res.data.msg || '移除失败')
            return
          }
          this.$message.success('移除成功')
          this.getList()
        })
        .finally(() => {
          this.selectionList = []
          this.$refs.crud.clearSelection()
          this.$emit('finished-remove')
        })
    },
    removeInvestigatorDetail(selectedIds, query) {
      removeInvestigatorDetail({ selectedIds, query })
        .then(res => {
          if (res.data.code !== 0) {
            this.$message.warning(res.data.msg || '移除失败')
            return
          }
          this.$message.success('移除成功')
          this.getList()
        })
        .finally(() => {
          this.selectionList = []
          this.$refs.crud.clearSelection()
          this.$emit('finished-remove')
        })
    },
    mtlRemove() {
      if (!this.selectionList.length) {
        this.$message.warning('请选择数据')
        return
      }
      let ids = this.selectionList.map(item => item.id)
      if (this.checkAll) {
        ids = []
      }
      this.remove(ids)
    },
    //设置搜索项配置
    setSearchConfig(projectCategory, settleMode) {
      const time = [
        {
          type: 'daterange',
          prop: 'time',
          format: 'yyyy-MM-dd HH:mm',
          dateType: 'datetimerange',
          startPlaceholder: '',
          endPlaceholder: '',
          width: '200px'
        }
      ]
      const area = [
        {
          placeholder: '搜索点位名称',
          prop: 'area'
        }
      ]
      if (projectCategory === PROJECT_CATEGORY.SPOT_INVESTIGATIONS && settleMode === SETTLE_MODE.POINT_POSITION) {
        this.searchConfig = [...time, ...area]
      } else {
        this.searchConfig = time
      }
    },
    setColumn(projectCategory, settleMode) {
      let resColumn = []
      const {
        column1,
        column2,
        column3,
        column4,
        column5,
        column6,
        column1_p,
        column2_p,
        column3_p,
        column4_p,
        column5_p,
        column6_p
      } = column
      if (projectCategory === PROJECT_CATEGORY.QUESTIONNAIRE_SURVEY) {
        //问卷调查
        switch (settleMode) {
          case SETTLE_MODE.ANSWER_NUMBER:
            resColumn = this.isInvestigator ? column1 : column1_p
            break
          case SETTLE_MODE.DAY:
          case SETTLE_MODE.LADDER_PRICING:
            resColumn = this.isInvestigator ? column2 : column2_p
            break
          default:
            break
        }
      } else if (projectCategory === PROJECT_CATEGORY.SPOT_INVESTIGATIONS) {
        //明察暗访
        switch (settleMode) {
          case SETTLE_MODE.POINT_POSITION:
            resColumn = this.isInvestigator ? column3 : column3_p
            break
          case SETTLE_MODE.LADDER_PRICING:
            resColumn = this.isInvestigator ? column4 : column4_p
            break
          case SETTLE_MODE.DAY:
            resColumn = this.isInvestigator ? column5 : column5_p
            break
          default:
            break
        }
      } else {
        //人工导入
        resColumn = this.isInvestigator ? column6 : column6_p
      }
      this.option.column = resColumn.slice(0, resColumn.length - Number(!this.isShowOpt))
    },
    // ‘结算方式’
    getSettleModeText(v, unitPrice, tiers) {
      switch (v) {
        case SETTLE_MODE.ANSWER_NUMBER:
          return '按答卷数量，每份' + unitPrice?.toFixed(2) + '元'
        case SETTLE_MODE.DAY:
          return '按天，每天' + unitPrice?.toFixed(2) + '元'
        case SETTLE_MODE.LADDER_PRICING:
          let res = tiers.reduce((pre, cur) => {
            return pre + cur.quantityLowerBound + '份～' + cur.quantityUpperBound + '份，按' + cur.unitPriceYuan + '元/份 '
          }, '')
          return '按阶梯计价，每天：' + res
        case SETTLE_MODE.POINT_POSITION:
          return '点位只要上报案件，按税后' + unitPrice?.toFixed(2) + '元 / 点位，参与结算'
        default:
          return ''
      }
    },
    //项目类型（0问卷1暗访2导入）
    handleProjectCategory(data) {
      switch (data) {
        case PROJECT_CATEGORY.QUESTIONNAIRE_SURVEY:
          return { text: '问卷调查', type: '', code: data }
        case PROJECT_CATEGORY.SPOT_INVESTIGATIONS:
          return { text: '明察暗访', type: 'warning', code: data }
        case PROJECT_CATEGORY.MANUAL_IMPORT:
          return { text: '人工导入', type: 'danger', code: data }
        default:
          return {}
      }
    },
    open(id, cId, projectCategory, settleMode, projectId, investigatorPhone, auditStatus, payStatus) {
      this.searchData = {}
      this.$nextTick(() => {
        this.$refs.searchCard?.clearData()
      })
      this.drawer = true
      this.id = id
      this.cId = cId
      this.projectId = projectId
      this.investigatorPhone = investigatorPhone
      this.auditStatus = auditStatus
      this.payStatus = payStatus
      this.checkAll = false
      this.$refs.crud?.clearSelection()
      //设置表格列配置
      this.setColumn(projectCategory, settleMode)
      //设置搜索项
      this.setSearchConfig(projectCategory, settleMode)
      this.getInvestigatorDetailCardTab() //获取统计卡片
      if (projectCategory === PROJECT_CATEGORY.MANUAL_IMPORT) {
        this.importProjectDetail() //获取项目，任务信息 (人工导入)
      } else {
        this.getInvestigatorDetail() //获取项目，任务信息
      }
      this.getInvestigatorDetailTableInfo() //右侧导航
    },
    onReset() {
      this.searchData = {}
      this.getList()
    },
    toSearch(value) {
      this.searchData = value
      this.getList()
    },
    sizeChange(v) {
      this.pagination.currentPage = 1
      this.pagination.pageSize = v
      this.getList()
    },
    currentChange(v) {
      this.pagination.currentPage = v
      this.getList()
    },
    checkAdjustDetail() {},
    selectionChange(list) {
      this.selectionList = list
    },
    //点击导航
    handleNodeClick(v) {
      let isExport = false
      if (v.children === undefined) {
        //子级
        !this.isInvestigator && (this.id = v.investigatorStatementId)
        this.cId = v.id
        isExport = false
      } else if (!v.children) {
        //父级（有子级）--> 人人工导入
        !this.isInvestigator && (this.id = v.investigatorStatementId)
        this.cId = v.id //v.id => projectId
        isExport = true
      } else {
        //父级（有子级）
        !this.isInvestigator && (this.id = v.children[0].investigatorStatementId)
        this.cId = v.children[0].id
        isExport = false
      }
      this.projectId = v.id
      //处理点击右侧导航点击事件后 任务名称的选中样式
      this.treeData.forEach(item => {
        if (item.children === null) {
          //人工导入
          item.checked = this.projectId === item.id
        }
        item.children &&
          item.children.forEach(c => {
            c.checked = c.id === this.cId
          })
      })
      this.getInvestigatorDetailCardTab() //获取统计卡片
      if (isExport) {
        this.importProjectDetail() //获取项目，任务信息 (人工导入)
      } else {
        this.getInvestigatorDetail() //获取项目，任务信息
      }
    },
    //表格上方的“未结算。。。”信息
    getUnitQuantityText(maxUnitPriceYuan, unitQuantity) {
      maxUnitPriceYuan ??= 0
      maxUnitPriceYuan = maxUnitPriceYuan.toFixed(2)

      if (this.payStatus === null && this.auditStatus === AUDIT_STATUS.PAID || this.payStatus === PAY_STATUS.PAY_SUCCESS || this.payStatus === PAY_STATUS.PAYING  ) {
        //如果结算单已支付，未结算0
        unitQuantity = 0
      }
      if (this.projectInfo.projectCategory.code === PROJECT_CATEGORY.QUESTIONNAIRE_SURVEY) {
        //问卷调查
        switch (this.settleMode) {
          case SETTLE_MODE.ANSWER_NUMBER:
            return `未结算答卷${unitQuantity}份，每份${maxUnitPriceYuan}元，`
          case SETTLE_MODE.DAY:
            return `未结算${unitQuantity}天，每天${maxUnitPriceYuan}元，`
          case SETTLE_MODE.LADDER_PRICING:
            return `未结算答卷${unitQuantity}份，`
          default:
            return ''
        }
      } else if (this.projectInfo.projectCategory.code === PROJECT_CATEGORY.SPOT_INVESTIGATIONS) {
        //明察暗访
        switch (this.settleMode) {
          case SETTLE_MODE.POINT_POSITION:
            return `未结算${unitQuantity}点位，每点位${maxUnitPriceYuan}元，`
          case SETTLE_MODE.LADDER_PRICING:
            return `未结算${unitQuantity}点位，`
          case SETTLE_MODE.DAY:
            return `未结算${unitQuantity}点位，每天${maxUnitPriceYuan}元，`
          default:
            return ''
        }
      } else {
        //人工导入
        return ''
      }
    },
    getTaskNums(item) {
      if (item.projectId !== this.taskNums.projectId) {
        this.taskNums.num = 0
        this.taskNums.projectId = item.projectId
      }
      return ++this.taskNums.num
    }
  },
  watch: {}
}
</script>

<style lang="scss" scoped>
::v-deep .el-drawer__body {
  @apply bg-card-bg-gray p-4;
}
.num-style {
  @apply text-medium font-semibold;
}
.content {
  height: calc(100% - 120px);
  .main {
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.06);
  }
  .active-class {
    @apply font-normal text-theme break-all;
    // &:hover {
    //   @apply text-theme;
    // }
  }
  .no-active-class {
    @apply break-all;
  }
}
::v-deep .el-tree {
  // color: #FFFFFF;// 白色字体
  background: rgba(0, 0, 0, 0); // 整体背景透明
  .el-tree-node {
    white-space: normal;
    .el-tree-node__content {
      height: 100%;
      align-items: start;
    }
  }
  .el-tree-node__expand-icon {
    color: rgba($color: #000000, $alpha: 0.65);
  }
  .el-tree-node__expand-icon.is-leaf {
    color: transparent;
  }
  .el-tree-node__content:hover {
    background: rgba(0, 0, 0, 0); // hover 节点背景色，否则是白色
  }
  .el-tree-node:focus > .el-tree-node__content {
    background-color: rgba(0, 0, 0, 0); // focus 节点背景透明，否则是白色
  }
}
.header-text-style {
  b {
    @apply num-style;
  }
}
</style>
<style lang="scss">
// .tree {
//   .el-tree-node {
//     white-space: normal;
//     .el-tree-node__content {
//       height: 100%;
//       align-items: start;
//     }
//   }
// }
</style>
